import { Condition } from '../dashboard/enums/condition.enum';
import { colors, grayScale } from '../ui/inline-styles/variables';

type ConditionToColor = { [P in Condition]: string };

export const conditionToColor = (condition: Condition): string => {
  const conditionToColorMap: ConditionToColor = {
    [Condition.Good]: colors.green,
    [Condition.Fair]: colors.orange,
    [Condition.Poor]: colors.red,
    [Condition.Disconnected]: grayScale['4'],
  };

  return conditionToColorMap[condition] || grayScale['4'];
};



// WEBPACK FOOTER //
// ./src/app/utils/condition-to-color.util.ts